import { action, global } from "../const";

const initialState = {
    height: window.innerHeight,
    userStrength: [],
    familyStrenght: [],
    teamStrenght: [],

    progressLevel: [],

    isOnline: true,

    snackVisible: false,
    snackMessage: undefined,
    snackVariant: "default",
    isEnableEnglish: false,

    isLoadingDialogVisible: false,
    isRecordException: false,
    app_language: "eng"
}

export default function settingReducer(state = initialState, data) {

    switch (data.type) {

        case action.UPDATE_ROOT_STATE:
            return Object.assign({}, state, data.payload)

        case action.IS_WINDOW_RESIZE:
            return { ...state, height: window.innerHeight }

        case action.IS_USER_ONLINE:
            return { ...state, isOnline: true }
        case action.IS_USER_OFFLINE:
            return { ...state, isOnline: false }

        case action.GET_DEVICE_HEIGHT:
            return { ...state, height: data.payload }

        case action.IS_ENGLISH_ENABLE:
            return { ...state, isEnableEnglish: true }
        case action.IS_ENGLISH_DISABLE:
            return { ...state, isEnableEnglish: false }

        case action.LOADING_DIALOG_TRUE:
            return { ...state, isLoadingDialogVisible: true }
        case action.LOADING_DIALOG_FALSE:
            return { ...state, isLoadingDialogVisible: false }

        case action.RECORD_EXCEPTION_TRUE:
            return { ...state, isRecordException: true }
        case action.RECORD_EXCEPTION_FALSE:
            return { ...state, isRecordException: false }

        case action.close_notification:
            return {
                ...state,
                snackMessage: undefined,
                snackVisible: false,
                snackVariant: "default"
            }

        case action.open_notification:
            let snackVariant = "default"
            if (data.variant) snackVariant = data.variant
            return {
                ...state,
                snackMessage: data.message,
                snackVisible: true,
                snackVariant
            }

        case action.APP_LANGUAGE:
            return { ...state, app_language: data.payload }

        default:
            break;
    }
    return state;
}